// Fulfillment resolver — maps a Partner Product's fulfillment_domain to the employee
// action + the domain module that owns it. Adding a product category later means adding
// a case HERE, not scattering `if category === 'LOAN'` across components.
import type { CreditOffer } from '@/features/credit/types';

export type ProductAction = { label: string; route: string };

export function productAction(o: Pick<CreditOffer, 'fulfillmentDomain' | 'fulfillmentReference'> & { category?: string }): ProductAction {
  if (o.category === 'SAVINGS') return { label: 'Start saving', route: '../loans' };
  switch (o.fulfillmentDomain) {
    case 'benefits':
      // Deep-link straight to the tenant's provisioned plan when we have its id, so the
      // employee lands on My Benefits with the enrol dialog pre-filled.
      return {
        label: 'Enroll',
        route: o.fulfillmentReference ? `../my-benefits?enroll=${o.fulfillmentReference}` : '../my-benefits',
      };
    case 'credit':
    default:
      return { label: 'Apply', route: '../loans' }; // loans/advances → Loans & Advances
  }
}

// Human label for a product category (badge).
export function categoryLabel(category: string): string {
  switch (category) {
    case 'INSURANCE': return 'Insurance';
    case 'HEALTH': return 'Health';
    case 'BENEFIT': return 'Benefit';
    case 'WELLNESS': return 'Wellness';
    case 'CREDIT': return 'Loan';
    case 'SAVINGS': return 'Savings';
    case 'DEVICE': return 'Device financing';
    case 'EDUCATION': return 'Education';
    case 'EMERGENCY': return 'Emergency credit';
    default: return category;
  }
}
